import React from 'react';
import { DefaultLayout } from '../layouts';
import { TitleSection } from "../components";
import MortgageRates  from '../components/ourRates-screen';

export default function LenderPage() {
  return (
    <DefaultLayout showApplyNowButton={false}>
      <TitleSection title="Mortgage Rates" bg="/images/team-bg.jpg" />
      <MortgageRates />
    </DefaultLayout>
  )
}